<template>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-if="! is_data_ready">
        <span class="loader"></span>
    </div>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0 text-center" v-else-if="!team">
        <p>No detail data found.</p>
    </div>
    <div class="col-12 col-md-8 col-lg-6 content mb-20 mb-lg-0" v-else>
        <div class="tab-content main-tabs-content">
            <div class="tab-pane fade show active">
                <header class="info-sub-head">

                    <!--					<div class="image-box">
                                                                    <img :src="team.flag" alt="team" />
                                                            </div>-->
                    <div class="info-body align-items-center">
                        <div class="info-body-left">
                            <h1>{{ team.name }} {{geth1}}</h1>
                            <time class="time" datetime="2020-02-11">{{ team.country }}</time>
                        </div>
                        <div class="info-body-right">
                            <div class="team-logo mt-0">
                                <img width="90" height="90" class="lazyload" :src="team.flag.resizeImage(90,90)" alt="team logo" /> 
                            </div>
                        </div>
                    </div>
                </header>
                <div class="nav-tabs-wrap">
                    <ul class="nav nav-tabs" role="tablist">
                        <!-- <li><router-link :to="{name: 'teamDetail.Matches'}" :class="{'active' : $route.name=='teamDetail.Matches'}">Matches</router-link></li>
                        <li><router-link :to="{name: 'teamDetail.Standings'}" :class="{'active' : $route.name=='teamDetail.Standings'}">Standings</router-link></li>
                        <li><router-link :to="{name: 'teamDetail.Results'}" :class="{'active' : $route.name=='teamDetail.Results'}">Results</router-link></li>
                        <li><router-link :to="{name: 'teamDetail.Players'}" :class="{'active' : $route.name=='teamDetail.Players'}">Players</router-link></li>
                        <li><router-link :to="{name: 'teamDetail.social'}" :class="{'active' : $route.name=='teamDetail.social'}">Social</router-link></li> -->

                        <li><router-link :to="{name: 'TeamDetails.Players'}" :class="{'active' : $route.name=='TeamDetails.Players'}">Players</router-link></li>
                        <li><router-link :to="{name: 'TeamDetails.Matches'}" :class="{'active' : $route.name=='TeamDetails.Matches'}">Matches</router-link></li>
                        <li><router-link :to="{name: 'TeamDetails.Social'}" :class="{'active' : $route.name=='TeamDetails.Social'}">Social</router-link></li>
                        <li><router-link :to="{name: 'TeamDetails.News'}" :class="{'active' : $route.name=='TeamDetails.News'}">News</router-link></li>



                    </ul>
                </div>
                <div class="tab-content">
                    <router-view />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'TeamDetails',

        data() {
            return {
                team: null,
            }
        },

        jsonld() {

            if (isServer)
                return {
                    "@context": "http://schema.org",
                    "@graph": []
                }

            if (!this.is_data_ready)
                return

                return {
           
                "@context": "https://schema.org",
                "@type": "SportsTeam",
                name: this.team.name,
                logo: this.team.flag,
                "url" : process.env.BASE_URL,
                "location": {
                        "@type": "Place",
                        "name": this.team.name + ", " + this.team.country,
                        "address": {
                                "@type": "PostalAddress",
                                "name": this.team.name + ", " + this.team.country,
                        }
                },
            }
        },

        metaInfo() {
            if (!this.team)
                return

            let title = this.team.name + " Players" + " - PlanetCricket.com";
            let description = this.team.name + " Players" + " - PlanetCricket.com";
            return {
                title: title,
                meta: this.$getMetaTags(title, description),
                link:[
                        {rel: 'canonical', href: 'https://planetcricket.com'+this.$route.path}],
            }
        },
        serverPrefetch() {
            if (this.$store.state.runSsr) {
                return this.main();
            }
        },
        computed: {

            geth1() {
                return   this.$route.path.split('/')[2][0].toUpperCase() + this.$route.path.split('/')[2].slice(1).toLowerCase()
            },
        },
        mounted() {
            this.main();
        },

        methods: {
            main() {
                return this.$axios
                        .get(this.$TEAM_DETAILS_API.replace(':team', this.$route.params.team))
                        .then(response => {
                            this.is_data_ready = true
                            this.team = response.data.result.team
                        })
                        .catch(error => console.log(error))
            },
        }
    }
</script>